<div class="modal-header">
    <h4 class="modal-title">{{ title }}</h4>
</div>
<form name="form" #form="ngForm">
    <div class="modal-body">
        <div class="row">
            <div class="col-md-4 mb-3">
                <div class="form-group">
                    <label for="sacrificialAnodeBagSize">Sacrificial Anode Bag Size</label>
                    <input
                        type="text"
                        class="form-control"
                        id="sacrificialAnodeBagSize"
                        [(ngModel)]="target.sacrificialAnodeBagSize"
                        name="sacrificialAnodeBagSize"
                    />
                </div>
            </div>
            <div class="col-md-4 mb-3">
                <div class="form-group">
                    <label for="installationLocation">Installation Location</label>
                    <input
                        type="text"
                        class="form-control"
                        id="installationLocation"
                        [(ngModel)]="target.installationLocation"
                        name="installationLocation"
                    />
                </div>
            </div>
            <div class="col-md-4 mb-3">
                <div class="form-group">
                    <label for="numberOfAnodeBags">Number of Anode Bags</label>
                    <input
                        type="text"
                        class="form-control"
                        id="numberOfAnodeBags"
                        [(ngModel)]="target.numberOfAnodeBags"
                        name="numberOfAnodeBags"
                    />
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-6 mb-3">
                <div class="form-group">
                    <label for="testStationTypeAndLocation">Test Station Type and Location</label>
                    <input
                        type="text"
                        class="form-control"
                        id="testStationTypeAndLocation"
                        [(ngModel)]="target.testStationTypeAndLocation"
                        name="testStationTypeAndLocation"
                    />
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-outline-secondary" (click)="cancel()">Cancel</button>
        <button type="button" class="btn btn-primary" (click)="save()">Save</button>
    </div>
</form>
